var map = {
	"./0.svg": 8146,
	"./1.svg": 4644,
	"./10.svg": 4518,
	"./11.svg": 1722,
	"./12.svg": 2652,
	"./13.svg": 467,
	"./14.svg": 9559,
	"./15.svg": 2939,
	"./16.svg": 8141,
	"./17.svg": 9205,
	"./18.svg": 1474,
	"./19.svg": 3102,
	"./2.svg": 3248,
	"./20.svg": 4424,
	"./21.svg": 6132,
	"./22.svg": 6048,
	"./23.svg": 1035,
	"./24.svg": 1235,
	"./25.svg": 5000,
	"./26.svg": 6325,
	"./27.svg": 4180,
	"./28.svg": 5666,
	"./29.svg": 7910,
	"./3.svg": 2701,
	"./30.svg": 8733,
	"./31.svg": 9014,
	"./32.svg": 5824,
	"./4.svg": 1005,
	"./5.svg": 9605,
	"./6.svg": 6281,
	"./7.svg": 6605,
	"./8.svg": 4351,
	"./9.svg": 9717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 236;